<template>
  <a-modal
    v-model="showModal"
    :title="title"
    width="72%"
    :footer="null"
    :maskClosable="false"
    :dialogStyle="{ top: '10%' }"
    @cancel="handleCancel"
  >
     <a-table
      :loading="loading"
      :columns="showColumns"
      :data-source="datas"
      :pagination="false"
      :rowKey="(record, i) => {return i}"
      :scroll="total>12?{y: 300 }:{}"
      size="small"
    >
      <div slot="zone">
        <span>{{ zone }}</span>
      </div>
      <div slot="namecn">
        <span>{{ namecn }}</span>
      </div>
    </a-table>
  </a-modal>
</template>
<script>
import {errMsg, warnMsg} from "../../../utils/CommonUtils.js"
export default {
  props: ["countryCode","month", "zone", "namecn"],
  data() {
    return {
      title: this.$t('dayActiveDevice.title'),
      total: 0,
      showModal: false,
      loading:true,
      datas: [],
      showColumns: [
        {
          title: this.$t('dayActiveDevice.columns.zone'),
          dataIndex: "zone",
          scopedSlots: { customRender: "zone" },
        },
        {
          title: this.$t('dayActiveDevice.columns.namecn'),
          dataIndex: "namecn",
          scopedSlots: { customRender: "namecn" },
        },
        {
          title: this.$t('dayActiveDevice.columns.date'),
          dataIndex: "dateStr",
        },
        {
          title: this.$t('dayActiveDevice.columns.count'),
          dataIndex: "count",
        },
      ],
    };
  },
 created(){
  const savedLocale = localStorage.getItem('locale');
    if (savedLocale) {
      this.$i18n.locale = savedLocale;
    }
    this.showModal = true
    this.init();
  },
  methods: {
    handleCancel() {
      this.showModal = false;
      this.$emit("day-active-device", false);
    },
    init(){
       this.axios.post(this.baseUrl + "getTodayCount?month=" + this.month +"&code="+this.countryCode+"&flag=1", "", {
          headers: { token: sessionStorage.getItem("token") },
        }).then((res) => {
          this.loading = false;
          if (res.status == 200) {
            if (res.data.code == 0) {
              this.total = res.data.count;
              this.datas = res.data.data;
            } else if (res.data.code == 1) {
              this.total = 0;
              this.datas = [];
            } else if (res.data.code == -1) {
              warnMsg(this.$t('dayActiveDevice.hint.warn.loginWarn'));
              setTimeout(() => {
                this.$router.push({ name: "login" });
              }, "2000");
            } else if (res.data.code == -2) {
              errMsg(this.$t('dayActiveDevice.hint.error.getDataErr'));
            }
          } else {
            errMsg(this.$t('dayActiveDevice.hint.error.getDataErr'));
          }
        }).catch(() => {
          this.loading = false;
          errMsg(this.$t('dayActiveDevice.hint.error.systemErr'));
        });
    }
  },
};
</script>
<style scoped>

</style>